import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Subject';
import {PaginationInterface} from '@app/app/shared/interfaces/pagiantion.interface';
import {ParkInterface} from '@app/app/shared/interfaces/park.interface';
import {ParkModel} from '@app/app/shared/models/park.model';
import {ParksFilterInterface} from '@app/app/shared/interfaces/park-filter.interface';
import {AWSService} from '@app/app/shared/services/aws.service';
import {ActivatedRoute} from '@angular/router';
import {UrlHelper} from '@app/app/shared/helpers/url.helper';

@Injectable()
export class ParksService {
  private _perPage = 5;
  private _parks: ParkInterface[] = [];
  private _filter: ParksFilterInterface;
  private _onFilterChanged$: Subject<{ parks: ParkInterface[], pagination: PaginationInterface }> = new Subject();

  source = new Subject<any>();
  searchObservable = this.source.asObservable();

  constructor(protected http: HttpClient,
              private route: ActivatedRoute,
              private aws: AWSService,
              private urlHelper: UrlHelper) {
  }

  public makePagination(data: any[], page: number): PaginationInterface {
    return {
      totalPages: data.length / this._perPage,
      currentPage: page,
      limit: this._perPage,
      per_page: this._perPage,
      last_page: data.length / this._perPage,
      current_page: page,
    };
  }

  private sortParks(parks) {
    return parks.sort(function (a, b) {
      return a.attributes.name > b.attributes.name;
    });
  }

  public fetchList(): Observable<ParkInterface[]> {
    return this.http.get<ParkInterface[]>(`${this.urlHelper.getPrefix()}/parks`).map((data) => {
      if (data) {
        this._parks = data['data'].map((park) => new ParkModel(park));
      }
      return this._parks;
    });
  }

  public getParks(page?: number, searchString?: string): { parks: ParkInterface[], pagination: PaginationInterface } {
    let _page;
    _page = typeof(searchString) !== 'undefined' ? 1 : Number(page);

    const parks = typeof(searchString) !== 'undefined' ?
      this.sortParks(this.search(searchString)) :
      this.sortParks(this._parks);

    return {
      parks: parks.slice(this._perPage * (_page - 1), this._perPage * (_page - 1) + this._perPage),
      pagination: this.makePagination(parks, _page),
    };
  }

  public search(searchString) {
    let searchedParks = this._parks;

    if (searchString) {
      searchedParks = searchedParks.filter((el) => {
        if (el.attributes.name.toLowerCase().indexOf(searchString.toLowerCase()) >= 0) {
          return el;
        }
      });
    }
    return searchedParks;
  }

  public set filter(data) {
    this._filter = Object.assign(this._filter, data);
    this._onFilterChanged$.next(this.getParks());
  }

  public get filter() {
    return this._filter;
  }

  public get parks() {
    return this._parks;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/parks.service.ts